// Public identifiers supplied by the project owner. These are not credentials.
export const googleAnalytics = Object.freeze({
  measurementId:'G-YVM137FR5G',
  propertyId:'559795688',
  firebaseProjectId:'stirup-c10de',
  androidStreamId:'16166258443',
  iosStreamId:'16166160458',
});
